<template>
  <el-form size="mini" v-model="fromSummit">
    <el-form-item label="分数">
      <el-input ref="fromPoint" placeholder="起始分" size="mini" style="width: 68px" v-model="fromSummit.fromPoint"></el-input>
      -
      <el-input placeholder="结束分" size="mini" style="width: 68px" v-model="fromSummit.toPoint"></el-input>
      <span style="padding-left: 10px">
        总计：
        <span style="color: red">{{ scoreDifference }}</span>
        分
      </span>
      <span style="padding-left: 10px">
        <label style="padding-right: 10px">报价文本包含预计时间</label>
        <el-switch v-model="fromSummit.showTime"></el-switch>
      </span>
    </el-form-item>
    <el-form-item label="铭文">
      <el-radio-group v-model="fromSummit.inscriptionId" size="mini">
        <el-radio-button border v-for="(item, index) in fromSummit.inscriptions" :key="index" :label="item.id">{{ item.start }}-{{ item.end }}</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="折扣">
      <el-radio-group v-model="fromSummit.discount" size="mini">
        <el-radio-button border v-for="(item, index) in fromSummit.discounts" :key="index" :label="item.discount">{{ item.name }}</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'Summit',
    data() {
      return {
        gameId: 17,
        fromSummit: {
          fromPoint: '',
          toPoint: '',
          showTime: true,
          inscriptionId: 0,
          inscriptions: [],
          discount: null,
          discounts: [],
        },
      };
    },
    computed: {
      scoreDifference() {
        const from = parseFloat(this.fromSummit.fromPoint) || 0;
        const to = parseFloat(this.fromSummit.toPoint) || 0;
        return to - from;
      },
    },
    mounted() {
      this.getInscriptions();
      this.getDiscount();
      this.loadQuoterTextFormat();
    },
    methods: {
      getInscriptions() {
        let url = '/api/company/inscriptions?gameId=' + this.gameId + '&pricingType=GOK_SUMMIT';
        this.$http.get(url).then(res => {
          this.fromSummit.inscriptions = res.data;

          if (this.fromSummit.inscriptions.length > 0) {
            this.fromSummit.inscriptionId = this.fromSummit.inscriptions[0].id;
          }
        });
      },
      loadQuoterTextFormat() {
        let url = '/api/company/format?gameId=' + this.gameId + '&pricingType=GOK_SUMMIT';
        this.$http.get(url).then(res => {
          let data = res.data;

          if (data != null) {
            this.fromSummit.showTime = data.showEstimateTime;
          }
        });
      },
      //获取折扣设置
      getDiscount() {
        let that = this;
        that.fromSummit.discounts = [];
        that.fromSummit.discount = null;
        axios.get('/api/company/discount', { params: { gameId: that.gameId, pricingType: 'GOK_SUMMIT' } }).then(res => {
          if (res != null) {
            that.fromSummit.discounts = res.data;
          }
          that.fromSummit.discounts.unshift({ name: '不打折', discount: null });
        });
      },
      focus() {
        this.$refs.fromPoint.focus();
      },
    },
  };
</script>

<style scoped></style>
